import React from 'react';
import { useSelector } from 'react-redux';
import { translations } from '../data/translation'; // Import translations
import { Config } from '../common/config';
import authrium_logo from '../images/authrium_logo.png';
export default function Footer() {
  const language = useSelector(state => state.language.language); // Get current language from Redux store
  const t = translations[language]; // Get the translation object based on the selected language

  return (
    <>
      <footer>
        <section className="footer_box">
          <div className="footer_001">
            <img src={authrium_logo} alt={t.logoAlt} />
            <div className="footer_info">
              <div className="footer_info_row">
                <span>{t.businessRegNo} | {t.representative}</span>
              </div>
              <div className="footer_info_row">
                <span>{t.companyName}</span>
                <span className="footer_info_divider">|</span>
                <span>{t.phoneLabel}</span>
              </div>
              <div className="footer_info_row">
                <span>{t.addressFull}</span>
              </div>
              <div className="footer_info_row">
                <span>{t.customerCenterHours}</span>
              </div>
              <div className="footer_info_row">
                <span>{t.lunchBreakNotice}</span>
              </div>
            </div>
          </div>
          <div className="footer_002">
            <ul className="footer_003">
              <li>
                <a href={`${Config.SHOPMAIN_SERVER}user-agreement`}>
                  {t.termsOfService}
                </a>
              </li>
              <li>
                <a href={`${Config.SHOPMAIN_SERVER}user-privacy`}>
                  {t.privacyPolicy}
                </a>
              </li>
            </ul>
            <div className="footer_004">
              <a href="mailto:naegift@naver.com" className="footer_email">
                naegift@naver.com
              </a>
              <p className="footer_copyright">
                {t.copyrightFull}
              </p>
            </div>
          </div>
        </section>
      </footer>
    </>
  );
}
